import React, { useCallback } from 'react';
import { StyleSheet } from 'react-native';
import { CardView } from 'design-system/CardView';
import Section from 'design-system/Section';
import { SettingsItemNavigate } from 'design-system/SettingsItem';
import IconSend from 'design-system/icons/IconSend';
import { selectIsGBUser } from 'reducers/selectors';
import { useAppSelector } from 'store/hooks';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import { showUnavailableOnWeb } from 'utils/webGate';
import AddToGroupWidget from '../share/AddToGroupWidget';
import { styles } from './styles';
/**
 * On web the transaction can be added to a group as in the app. Sharing the bill
 * sends payment requests paid through Emma, so it stays in the app and the row
 * shows the QR code that opens this transaction there.
 */
const TransactionShareSection = ({ transaction }) => {
    const isGBUser = useAppSelector(selectIsGBUser);
    const navigation = useMainStackNavigation();
    const onShareBill = useCallback(() => {
        showUnavailableOnWeb(`emma://transactions/${transaction.id}`, 'Share the bill');
    }, [transaction.id]);
    const showShareBill = isGBUser && transaction.amount < 0 && !transaction.isPending;
    return (<Section title="Share the cost" style={styles.section}>
      <CardView noMarginTop noMarginBottom style={localStyles.overflowHidden}>
        {showShareBill ? (<SettingsItemNavigate icon={<IconSend />} titleFirst title="Share the bill" description="Get paid back by your friends" onPress={onShareBill}/>) : null}
        <AddToGroupWidget navigation={navigation} transaction={transaction}/>
      </CardView>
    </Section>);
};
const localStyles = StyleSheet.create({
    overflowHidden: {
        overflow: 'hidden',
    },
});
export default TransactionShareSection;
